import { render } from "./help_page.vue?vue&type=template&id=7086ed58"
import script from "./help_page.vue?vue&type=script&lang=js"
export * from "./help_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__